<template>
  <a-dropdown
    v-model:open="isEditing"
    :trigger="['click']"
    placement="rightTop"
    overlayClassName="select_timestamp_edit_dropdown"
  >
    <div
      class="flex items-center gap-2 p-2 cursor-pointer dropdown_item"
      @click.stop="handleEdit"
    >
      <ThemeImage
        :icon="imageNames.EDIT"
        alt="edit_icon"
        class="size-5"
      />
      <span class="text-sm text_color">Edit property</span>
      <ThemeImage
        :icon="imageNames.RIGHT_ARROW"
        alt="arrow_right"
        class="size-3 ml-auto"
      />
    </div>
    <template #overlay>
      <div class="select_timestamp_edit_dropdown_content">
        <SelectTimestampEditDropdown
          :entity-type="entityType"
          :property-meta="propertyMeta"
          :project-id="projectId"
          :service="service"
          @cancel="exitEditMode"
          @saved="handleSaved"
        />
      </div>
    </template>
  </a-dropdown>
</template>

<script setup>
import { ref } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import SelectTimestampEditDropdown from "../SelectTimestampEditDropdown.vue";

const props = defineProps({
  propertyMeta: {
    type: Object,
    default: null,
  },
  entityType: {
    type: String,
    required: true,
  },
  projectId: {
    type: [String, Number],
    default: null,
  },
  service: {
    type: String,
    default: null,
  },
  isDynamicObject: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["property-updated", "close"]);

const isEditing = ref(false);

const handleEdit = () => {
  isEditing.value = true;
};

const exitEditMode = () => {
  isEditing.value = false;
};

const handleSaved = (data) => {
  exitEditMode();
  emit("property-updated", {
    propertyMeta: props.propertyMeta,
    newName: props.propertyMeta.name,
    response: data.response,
    isSelectTimestampChange: true,
  });
  emit("close");
};
</script>

<style>
.select_timestamp_edit_dropdown_content {
  background: var(--dropdown-bg);
  border-radius: 8px;
  box-shadow: var(--dropdown-boxshadow);
  width: fit-content;
}
</style>
